<template>
  <div>
    <div class="row row--no-grep">
      <div class="col-md-6-12 px-0">
        <rir-input
          :readonly="!(isAdmin && !isRead)"
          label="Название"
          v-model="kpiData.name"
        />
      </div>
    </div>
    <div
      v-if="isAdmin"
      class="row row--no-grep">
      <div class="col-md-6-12 px-0">
        <rir-select
          :readonly="isRead"
          :items="listOfTypes"
          v-model="kpiData.dataType"
          @change="changeType"
          label="Тип данных"
        />
      </div>
    </div>
    <component
      :is="isComponentForm"
      :readonly="isRead"
      v-model="kpiData"
    />
    <div
      v-if="isAdmin"
      class="row row--no-grep">
      <div class="col-md-6-12 px-0">
        <rir-input
          :readonly="isRead"
          v-model="kpiData.units"
          label="Единицы"
        />
      </div>
    </div>
    <div
      v-if="isString"
      class="row row--no-grep">
      <div class="col-md-6-12 px-0">
        <rir-select
          :items="listOfStyles"
          :readonly="isRead"
          v-model="kpiData.style"
          label="Стиль отображения"
        />
      </div>
    </div>
    <div class="row row--no-grep">
      <div class="col-md-6-12 px-0">
        <rir-button
          @click="isStatusEdit.action"
        >
          {{ isStatusEdit.text }}
        </rir-button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Kpi from "@/models/Kpi";
import { KpiApi } from "@/api/KpiApi";
import SettingFieldInt from "@/components/kpiField/SettingFieldInt";
import SettingFieldDate from "@/components/kpiField/SettingFieldDate";
import SettingFieldString from "@/components/kpiField/SettingFieldString";
import { DateFormatted } from '@/plugins/DateFormatted'
export default {
  name: 'default-form',
  data: (vm) => ({
    kpiData: new Kpi(vm.kpi),
    isRead: true,
    listOfTypes: [
      {id: 'string', value: 'Строка'},
      {id: 'int', value: 'Число'},
      {id: 'date', value: 'Дата'},
    ],
    listOfStyles: [
      {id: null, value: 'нет'},
      {id: 'is-normal', value: 'в норме'},
      {id: 'is-invalid', value: 'превышен'},
    ],
  }),
  props: {
    kpi: {
      type: Object,
      default: () => new Kpi()
    }
  },
  computed: {
    ...mapGetters('session', ['isAdmin']),
    isComponentForm () {
      switch (this.kpiData.dataType) {
        case 'int':
          return SettingFieldInt
        case 'date':
          return SettingFieldDate
        default:
          return SettingFieldString
      }
    },
    isString () {
      return this.kpiData.dataType === 'string'
    },
    isStatusEdit () {
      return {
        action: this.isRead ? this.setEditForm : this.saveData,
        text: this.isRead ? 'Редактировать' : 'Сохранить'
      }
    }
  },
  methods: {
    changeType () {
      this.kpiData.value = null
      this.kpiData.minValue = null
      this.kpiData.maxValue = null
      this.kpiData.maxValue = null
      this.kpiData.style = null
    },
    async setEditForm () {
      const { data } = await KpiApi.changeMark(this.kpi.id, this.isRead ? 'PICK' : 'RELEASE')
      if (data.canEdit) {
        this.isRead = !this.isRead
      } else {
        this.$notification({
          icon: 'warning',
          type: 'error',
          text: `Данная запись уже редактируется пользователем ${data.editingBy} с ${(new DateFormatted(data.editStartTime)).ruFormat()}!`
        })
      }
    },
    async saveData () {
      if (
          this.kpiData.maxValue !== null
          && this.kpiData.minValue !== null
          && Number(this.kpiData.minValue) > Number(this.kpiData.maxValue)
      ) {
        this.$notification({
          icon: 'warning',
          type: 'warning',
          text: 'Интервал указан неверно!'
        })
        return
      }
      const res = await KpiApi.updateData(this.kpiData)
      if (res) {
        this.isRead = !this.isRead
      }
    }
  }
}
</script>
